import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-bold text-white">友田真希</span>
            </Link>
            <p className="text-secondary-400 text-sm leading-relaxed max-w-md">
              友田真希官方粉丝应援网站。汇聚最新动态、作品资讯、个人经历与粉丝应援资源，带你全面了解友田真希的魅力与艺能世界。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://www.instagram.com/yuta_maki_official"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white transition-all duration-300"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://twitter.com/yuta_maki"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white transition-all duration-300"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://youtube.com/@yutamaki_official"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white transition-all duration-300"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">
              <a href="/category/latest" className="hover:text-primary-400 transition-colors">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-secondary-400 hover:text-white text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">
              <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-secondary-400 hover:text-white text-sm transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-400 hover:text-white text-sm transition-colors">
                  艺人履历
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-400 hover:text-white text-sm transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-secondary-500 text-xs">
            &copy; {currentYear} 友田真希官方粉丝应援会. All rights reserved.
          </p>
          <p className="text-secondary-600 text-xs">
            本站为非营利性粉丝应援网站
          </p>
        </div>
      </div>
    </footer>
  );
}